<template>
  <div id="app" class="site-wrapper">
    <v-app>
      <Header />
      <main>
        <router-view />
      </main>
      <Footer />
    </v-app>
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default {
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss">
@import "../assets/plugins/bootstrap-4.3.1/css/bootstrap.min.css";
@import "../assets/plugins/meanmenu/meanmenu.css";
@import "../assets/fonts/ep-icon-fonts/css/ep-font.css";
@import "../assets/fonts/fontawesome-5/css/all.min.css";
@import "../assets/css/settings.css";
@import "../assets/css/style.css";
@import "../assets/css/custom.css";
  body {
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }
  main {
    min-height: calc(100vh - 200px);
  }
</style>